"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const add_basic_auth_header_1 = __importDefault(require("./middleware/before-request/add-basic-auth-header"));
const prepare_headers_1 = __importDefault(require("./middleware/after-response/prepare-headers"));
const prepare_response_1 = __importDefault(require("./middleware/after-response/prepare-response"));
const request_client_1 = __importStar(require("./request-client"));
const baseClient = (0, request_client_1.default)({
    timeout: request_client_1.DEFAULT_REQUEST_TIMEOUT,
    headers: {
        'user-agent': 'Segment (Actions)'
    },
    beforeRequest: [
        add_basic_auth_header_1.default
    ],
    afterResponse: [prepare_response_1.default, prepare_headers_1.default]
});
function createRequestClient(...requestOptions) {
    let client = baseClient;
    for (const options of requestOptions ?? []) {
        client = client.extend(options);
    }
    return (url, options) => {
        return client(url, options);
    };
}
exports.default = createRequestClient;
//# sourceMappingURL=create-request-client.js.map